import { useEffect, useState } from "react";
import { useAssetContext } from "../../DataContext/AssetContext";
import { useAssetRevenue } from "./useAssetRevenue";
import RevenueToggle from "./RevenueToggle";
import RevenueSummaryTable from "./RevenueSummaryTable";
import RevenueGroupDropdown from "../../DropDowns/RevenueGroupDropdown/RevenueGroupDropdown";
import RevenueWaterfall from "./RevenueWaterfall";

const AssetRevenuePage = () => {

  const { selectedAsset, selectedDateRange } = useAssetContext();

  const [view, setView] = useState<
    "DAY" | "MTD" | "YTD"
  >("DAY");
  // const { selectedRevenue, setSelectedRevenue } = useAssetContext();
  const [selectedRevenue, setSelectedRevenue] =
  useState("settlement_charge_name");

  const [breakdownView, setBreakdownView] =
    useState<
      "TOTAL" | "PEAK" | "OFF_PEAK" | "ALL"
    >("TOTAL");
//     
  const { data, loading } = useAssetRevenue(
    selectedAsset?.asset_id ?? null,
    selectedDateRange,
    selectedRevenue
  );

  const startDate = selectedDateRange;
//  
  const getWaterfallByView = () => {
    if (!data?.estimatedTree) return [];

    const groupDepth: Record<string, number> = {
      market_type: 0,
      award_type: 1,
      product: 2,
      settlement_charge_name: 3,
      total: 0,
    };
    const targetDepth = groupDepth[selectedRevenue] ?? 0;
    const groupedValues = new Map<string, number>();
    const formatLabel = (label: string) => selectedRevenue === "settlement_charge_name"
      ? label
          .replace(/^(\d+)\s+\(CC\s+\d+\)\s+/, "$1 ")
          .replace("Estimated Day Ahead Revenue", "Estimated DA Revenue")
      : label;

    const getValue = (node: any) => {
      const source =
        view === "DAY"
          ? node.yesterday
          : view === "MTD"
          ? node.month_to_date
          : node.year_to_date;

      return breakdownView === "PEAK"
        ? source?.PEAK || 0
        : breakdownView === "OFF_PEAK"
        ? source?.OFF_PEAK || 0
        : source?.TOTAL || 0;
    };

    const collectGroups = (nodes: any[], depth = 0) => {
      nodes.forEach((node) => {
        const isLeaf = !node.children?.length;
        if (depth === targetDepth || isLeaf) {
          const label = formatLabel(node.label);
          groupedValues.set(
            label,
            (groupedValues.get(label) || 0) + getValue(node)
          );
          return;
        }

        collectGroups(node.children, depth + 1);
      });
    };

    collectGroups(data.estimatedTree);

    return Array.from(groupedValues, ([label, value]) => ({ label, value }))
      .filter((node) => node.value !== 0);
  };
  // useEffect(() => {

  //   if (!selectedRevenue) {
  //     setSelectedRevenue("Charge Code");
  //   }
  // }, []);
  if (loading && !data) {
    return (
      <div className="p-6">
        Loading revenue data...
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className="p-6">
      
      <RevenueSummaryTable
        title=""
        data={data.estimatedTree}
        view={view}
        breakdownView={breakdownView}
        onBreakdownChange={setBreakdownView}
      />
      <div className="mt-6">
        <RevenueToggle
          value={view}
          onChange={(v) =>
            setView(v as "DAY" | "MTD" | "YTD")
          }
        />
      </div>
      <div className="mt-6 flex items-center gap-4">
        <div className="w-[250px]">
          <label className="block text-sm text-gray-600 mb-1">
            Revenue Group
          </label>
          <RevenueGroupDropdown
            selectedValue={selectedRevenue}
            onChange={setSelectedRevenue}
            isAssetRevenueTab={true}
          />
        </div>
      </div>
      <div className="mt-6">
        <RevenueWaterfall
          data={getWaterfallByView()}
        />
      </div>
    </div>
  );
};

export default AssetRevenuePage;